import { getCanvasDimensions } from 'components/VideoTemplateEditor/utils';
import { TemplateAction } from '../action-types';
import { VideoTemplateStateContent } from '../types';
import { updateSlideEffectText } from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'CONTAINER_RESIZE': {
      const container = action.payload;
      const [width, height] = getCanvasDimensions(container, state.aspectRatio);
      return {
        ...state,
        canvas: { height, width },
        container,
      };
    }

    case 'IMAGE_EFFECT_TEXT_UPDATE': {
      const { id, text } = action.payload;
      return updateSlideEffectText(state, id, text);
    }

    default:
      return state;
  }
}
